import MethodsTags from './methods.tags'
import MethodsRelatedFamily from './methods.relatedFamily'

export default {
  ...MethodsTags,
  ...MethodsRelatedFamily,
  isSet() {
    return this.ready.state === 'set'
  },
  bannedWordForDescription: false,
  createDescription(options) {
    return {
      language: options.language || '',
      localization: options.localization || '',
      description: options.description || ''
    }
  },
  setDescriptions() {
    return new Promise(resolve => {
      /**
       * If no description, set default.
       */
      if (
        this.descriptions.length === 0 ||
        !this.descriptions.some(d => d.language === this.$store.getters['settings/language'])
      ) {
        const defaultDes = this.submissionFamilyDescriptions.filter(d => d.language === this.$store.getters['settings/language'])[0]
        const des = typeof defaultDes === 'object'
          ? defaultDes
          : this.createDescription({ language: this.$store.getters['settings/language'] })
        this.descriptions.unshift(des)
      }
      /**
       * Add descriptions from submission $store data.
       */
      for (const d of this.submissionFamilyDescriptions) {
        if (
          d.language !== this.$store.getters['settings/language'] &&
          !this.descriptions.some(l => l.language === d.language)
        ) {
          this.descriptions.push(this.createDescription({
            language: d.language,
            localization: this.getLocalization(d.language),
            description: d.description
          }))
        }
      }
      /**
       * Check if some localization don’t have descriptions.
       */
      for (const l of (this.locales.values || [])) {
        if (!this.descriptions.some(d => l.value === d.language)) {
          this.descriptions.push(this.createDescription({
            language: l.value,
            localization: this.getLocalization(l.value)
          }))
        }
      }
      /**
       * Remove if.
       */
      this.descriptions.forEach((d, idx) => {
        if (d.language !== this.$store.getters['settings/language']) {
          if (!(this.locales.values || []).some(l => l.value === d.language)) {
            this.descriptions.splice(idx, 1)
          }
        }
      })
      /**
       * Done
       */
      resolve()
    })
  },
  setLocales() {
    return new Promise(resolve => {
      /**
       * Set options.
       */
      this.locales.setOptions({
        obj: [
          { value: 'de', label: 'German' },
          { value: 'ja', label: 'Japanese' }
        ],
        value: 'value',
        name: 'label',
        multiple: true
      })
      /*
       * Set values.
       */
      const localizations = []
      for (const d of this.submissionFamilyDescriptions) {
        const l = this.locales.options.filter(l => l.value === d.language)[0]
        if (typeof l === 'object') {
          localizations.push(l)
        }
      }
      this.locales.setValues({
        obj: localizations,
        value: 'value',
        name: 'label',
        multiple: true
      })
      /**
       * Done
       */
      resolve()
    })
  },
  updateLocalesValues(val) {
    /**
     * Updates the locales.
     */
    this.locales.update(val, () => {
      this.setDescriptions()
      this.commitChange()
    })
  },
  hasLocalizations() {
    /**
     * Return {Boolean}
     */
    return Array.isArray(this.locales.values)
      ? this.locales.values.length > 0
      : false
  },
  getLocalization(iso) {
    /**
     * Lookup language name in localeOptions.
     */
    const lang = this.locales.options.filter(l => l.value === iso)[0]
    /**
     * Return {String}
     */
    return typeof lang === 'object' ? lang.label : ''
  },
  removeLocalization(idx) {
    /**
     * Remove localization from locales.
     * Will automatically fire fou-select update.
     */
    this.locales.remove(idx)
  },
  getCategory() {
    return this.$store.dispatch('categories/get')
  },
  setCategory() {
    return new Promise(resolve => {
      /**
       * Set options.
       */
      this.getCategory()
        .then(() => {
          this.category?.setOptions({
            obj: this.$store.getters['categories/list'],
            value: 'myfontsId',
            name: 'name',
            multiple: true
          })
          /**
           * Set values.
           */
          const isCategoryAvailable = this.submissionCategory.hasOwnProperty('name') && this.submissionCategory.hasOwnProperty('myfontsId')
          if (this.submissionCategory.length === 0 || !isCategoryAvailable) {
            this.category.setValues({
              obj: this.category.options[0],
              value: 'value',
              name: 'label'
            })
          } else {
            this.category.setValues({
              obj: this.submissionCategory,
              value: 'myfontsId',
              name: 'name'
            })
          }
          resolve()
        })
    })
  },
  updateCategoryValues(val) {
    /**
     * Updates the categories.
     */
    if (val === null) {
      val = this.category.options[0]
    }
    this.category.update(val, this.commitChange)
  },
  getApiCategory() {
    return this.category.getApiValues({
      value: 'myfontsId',
      name: 'name'
    })
  },
  commitChange() {
    if (this.tagCountCheck() > this.tagsLength) {
      return false;
    }
    this.updateSubmission(false, 'family-desc', this.bannedWordForDescription)
  },
  handleChangeAiTextEditor(value) {
    this.aiTextEditorChangeCount = this.aiTextEditorChangeCount + 1;
    this.descriptions[0].description = value;
  },
  handleBlurAiTextEditor(errorStatus) {
    this.aiTextEditorErrors = errorStatus;
    if (this.aiTextEditorChangeCount > 0) {
      this.commitChange();
    }
  },
  updateBannedWordStatus(status) {
    this.bannedWordForDescription = status
  },
  buildSubmission() {
    return new Promise(resolve => {
      const descriptions = []
      for (const d of this.descriptions) {
        if (
          d.language === this.$store.getters['settings/language'] ||
          (this.locales.values || []).some(l => l.value === d.language)
        ) {
          descriptions.push({
            language: d.language,
            description: d.description
          })
        }
      }
      this.submissionFamilyDescriptions = descriptions
      this.submissionTags = this.getApiTags()
      this.submissionFamilies = this.getApiFamilies()
      this.submissionCategory = this.getApiCategory()

      if (this.aiTagsInitialized && this.visibleAiTags?.length > 0) {
        const aiTags = this.visibleAiTags.map(tag => ({
          id: 'AI_GENERATED',
          name: tag.name
        }))
        const aiTagNames = aiTags.map(t => t.name.toLowerCase())
        const userOnlyTags = this.submissionTags.filter(
          t => !aiTagNames.includes(t.name.toLowerCase())
        )
        this.submissionTags = [...userOnlyTags, ...aiTags]
      }

      this.submission.excludedAiTags = [...this.localExcludedAiTags]

      resolve()
    })
  }
}
